<template>
  <div class="calendar">
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <calendar></calendar>
      </div>
    </div>
  </div>
</template>

<script>
  import Calendar from '@/views/Calendar/components/Calendar.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      Calendar
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Calendar/Calendar.vue?9cdf4778